/**
 * Returns all correlations of a certain atom type.
 *
 * @param {Values} correlations
 * @param {string} atomType
 */
export function getCorrelationsByAtomType(correlations, atomType) {
    return correlations
        ? correlations.filter((correlation) => correlation.atomType === atomType)
        : [];
}
//# sourceMappingURL=getCorrelationsByAtomType.js.map